import Vue from 'vue';

Vue.filter('array', function (val, type) {
    if (!val || !val.length) return '';
    let data = '';
    val.forEach(i => {
        if (data) data += ', ';
        data += i;
    });
    return data;
});